require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-return-to-exercise.json") })
        }
      }, "path---blog-return-to-exercise");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-return-to-exercise!./.cache/json/blog-return-to-exercise.json
// module id = 306
// module chunks = 231608221292675